import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

export const api = {
  getFeaturedProfessionals: (params = {}) =>
    axios.get(`${API_BASE}/professionals/featured`, { params }),

  getJobsPreview: (limit = 8) =>
    axios.get(`${API_BASE}/jobs/public-preview`, { params: { limit } }),

  submitContact: (data) =>
    axios.post(`${API_BASE}/contact`, data),
};

export default api;
